const roles = {
    administrador: 'administrador',
    CGA: 'CGA',
    CA: 'CA',
    PA: 'PA',
    padre: 'padre',
    facturacion: 'facturacion',
    rrhh: 'rrhh',
    tutor: 'tutor',
    enfermeria: 'enfermeria',
    cocina: 'cocina',
    coordinador_comedor: 'coordinador_comedor',
    coordinador_ruta: 'coordinador_ruta',
    coordinador_permanencia: 'coordinador_permanencia',
    secretaria: 'secretaria',
    profesor: 'profesor',
    coordinador_etapa: 'coordinador_etapa',
    coordinador_curso: 'coordinador_curso',
    coordinador_patio: 'coordinador_patio',
    comunicacion: 'comunicacion',
    suplantador: 'suplantador'
}

export {
    roles
}